/**
 * Client-side buyer analytics event buffer (Milestone 28).
 * TODO(M29): Replace with server-backed event warehouse.
 */
const STORAGE_KEY = "automap_buyer_analytics_events";
const MAX_EVENTS = 500;

function readEvents() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeEvents(events) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events.slice(-MAX_EVENTS)));
  } catch {
    // localStorage blocked — silent fail
  }
}

export function appendBuyerAnalyticsEvent(event) {
  const events = readEvents();
  events.push(event);
  writeEvents(events);
  return event;
}

export function listBuyerAnalyticsEvents({ limit = MAX_EVENTS } = {}) {
  const events = readEvents();
  return events.slice(-limit);
}

export function clearBuyerAnalyticsEvents() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
